<template>
  <form @submit.prevent="submitForm" class="w-full">
    <div class="mb-4">
      <input
        type="text"
        v-model="formData.fullname"
        placeholder="Your name"
        class="w-full p-3 bg-white/30 backdrop-blur-sm rounded-lg text-white placeholder-white/70 border border-white/20 focus:outline-none focus:border-white/50"
      />
    </div>
    <div class="mb-4">
      <input
        type="email"
        v-model="formData.email"
        placeholder="Your email"
        required
        class="w-full p-3 bg-white/30 backdrop-blur-sm rounded-lg text-white placeholder-white/70 border border-white/20 focus:outline-none focus:border-white/50"
      />
    </div>
    <div class="mb-4">
      <textarea
        v-model="formData.message"
        placeholder="Your message"
        rows="4"
        class="w-full p-3 bg-white/30 backdrop-blur-sm rounded-lg text-white placeholder-white/70 border border-white/20 focus:outline-none focus:border-white/50 resize-none"
      ></textarea>
    </div>
    <div class="text-right">
      <button
        type="submit"
        :disabled="submitting"
        class="bg-brand hover:bg-brand-light text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-300 drop-shadow-lg focus:outline-none focus:ring-2 focus:ring-brand focus:ring-opacity-50 disabled:opacity-70 disabled:cursor-not-allowed w-full mt-4"
        :class="{ 'opacity-70 cursor-not-allowed': submitting }"
      >
        <span v-if="submitting" class="inline-block animate-spin mr-2">↻</span>
        {{ submitting ? "Sending..." : "Send Message" }}
      </button>
    </div>
    <div
      v-if="formStatus === 'success'"
      class="mt-4 p-3 bg-green-500/30 text-white rounded-lg"
    >
      Thank you for your message! We'll get back to you soon.
    </div>
    <div
      v-if="formStatus === 'error'"
      class="mt-4 p-3 bg-red-500/30 text-white rounded-lg"
    >
      Sorry, there was an error sending your message. Please try again.
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        fullname: "",
        email: "",
        message: ""
      },
      submitting: false,
      formStatus: null
    };
  },
  methods: {
    async submitForm() {
      this.submitting = true;
      this.formStatus = null;

      try {
        // Create FormData object for submission
        const formData = new FormData();

        // Add the ActiveCampaign required fields
        formData.append("u", "6");
        formData.append("f", "6");
        formData.append("s", "");
        formData.append("c", "0");
        formData.append("m", "0");
        formData.append("act", "sub");
        formData.append("v", "2");
        formData.append("or", "7dbad05c0961b907ac59c01c02782b57");

        // Add user data
        formData.append("fullname", this.formData.fullname);
        formData.append("email", this.formData.email);
        formData.append("field[177]", this.formData.message); // map message to usermsg field
        // https://iifymcom.activehosted.com/app/forms/6
        // Make the POST request to ActiveCampaign
        const response = await fetch("https://iifymcom.activehosted.com/proc.php", {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json"
          }
        });

        // Handle the response
        if (response.ok) {
          this.formStatus = "success";
          this.resetForm();
        } else {
          this.formStatus = "error";
        }
      } catch (error) {
        console.error("Form submission error:", error);
        this.formStatus = "error";
      } finally {
        this.submitting = false;
      }
    },
    resetForm() {
      this.formData = {
        fullname: "",
        email: "",
        message: ""
      };
    }
  }
};
</script>

<style>
/* ActiveCampaign specific form styling */
._form {
  @apply space-y-6 max-w-xl mx-auto;
}

._form-content {
  @apply space-y-4;
}

._form_element {
  @apply mb-4;
}

._field-wrapper {
  @apply w-full;
}

._form_element input[type="text"],
._form_element input[type="email"],
._form_element textarea {
  @apply w-full px-4 py-3 rounded-lg bg-white text-gray-700;
}

._button-wrapper ._submit {
  @apply w-full px-6 py-3 bg-blue-500 hover:bg-blue-600 text-white font-semibold rounded-lg transition-colors duration-200;
}

/* Remove the :deep selector as it's not needed for external embedded forms */
._form-thank-you {
  @apply text-center text-white;
}

/* Handle form labels if needed */
._form_element label {
  @apply block text-white mb-2;
}

/* Error states */
._error-inner {
  @apply text-red-500 text-sm mt-1;
}

._form_element._has_error input {
  @apply border-red-500;
}
</style>
